
export class GameVars {

    public static scaleY: number;
    public static scaleCorrectionFactor: number;
    public static gameData: GameData;
    public static gameAnalytics: any;
    public static gameText: any;
    public static currentScene: Phaser.Scene;
    public static paused: boolean;
    public static gameOver: boolean;
    public static turretSelectedOn: boolean;
    public static loopNumber: number;
    public static loopRate: number;
    public static loopVolume: number;
    public static dangerRate: number;
    public static waveOver: boolean;
    public static semiPaused: boolean;
    public static enemiesData: any;
    public static turretsData: any;
    public static wavesData: any;
    public static mapsData: MapObject[];
    public static currentMapData: MapObject;
    public static currentMapId: number;
    public static currentWave: number;
    public static autoSendWave: boolean;
    public static timeStepFactor: number;
    public static enemiesPathCells: {r: number, c: number} [];
    public static plateausCells: {r: number, c: number} [];
    public static initialLogsObjects: LogsObject;
    public static logsObject: LogsObject;
    public static levelObject: LevelObject;
    public static seedRandom: seedrandom.prng;
    public static obstaclesBoard: number[][];

    public static areValidDomains(domains: string[]): boolean {

        if (domains.length === 0) {
            return true;
        }

        const hostname = window.location.hostname;
        const referrer = document.referrer;

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {

                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static fixNumber(n: number): number {
            
        return isNaN(n) ? 0 : Math.round(1e5 * n) / 1e5;
    }
   
    public static formatTime(timeInSeconds: number): { str: string, h: string, m: string, s: string } {

        if (isNaN(timeInSeconds) || timeInSeconds > 24 * 3600) {
            return { str: "0:00:00", h: "00", m: "00", s: "00" };
        }

        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds - (hours * 3600)) / 60);
        const seconds = timeInSeconds - (hours * 3600) - (minutes * 60);

        let h = hours.toString();
        let m = minutes.toString();
        let s = seconds.toString();

        if (hours < 10) {
            h = "0" + hours;
        }

        if (minutes < 10) {
            m = "0" + minutes;
        }

        if (seconds < 10) {
            s = "0" + seconds;
        }

        return { str: h + ":" + m + ":" + s, h: h, m: m, s: s };
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static getDate(): string {

        const date = new Date();

        const day = date.getDate();
        const weekDay = date.getDay();

        let weekDayStr: string;

        switch (weekDay) {

            case 0:
                weekDayStr = "SUN,";
                break;
            case 1:
                weekDayStr = "MON,";
                break;
            case 2:
                weekDayStr = "TUE,";
                break;
            case 3:
                weekDayStr = "WED,";
                break;
            case 4:
                weekDayStr = "THU,";
                break;
            case 5:
                weekDayStr = "FRI,";
                break;
            case 6:
                weekDayStr = "SAT,";
                break;
            default:
        }

        const month = date.getMonth();

        let monthStr: string;

        switch (month) {

            case 0:
                monthStr = "JAN";
                break;
            case 1:
                monthStr = "FEB";
                break;
            case 2:
                monthStr = "MAR";
                break;
            case 3:
                monthStr = "APR";
                break;
            case 4:
                monthStr = "MAY";
                break;
            case 5:
                monthStr = "JUN";
                break;
            case 6:
                monthStr = "JUL";
                break;
            case 7:
                monthStr = "AUG";
                break;
            case 8:
                monthStr = "SEPT";
                break;
            case 9:
                monthStr = "OCT";
                break;
            case 10:
                monthStr = "NOV";
                break;
            case 11:
                monthStr = "DEC";
                break;
            default:
        }


        return weekDayStr + " " + day + " " + monthStr;
    }
}
